import React, {useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons'

const RoleInfo: React.FC = () => {
  const [showInfoText, setShowInfoText] = useState(false)

  return (
    <div className="flex justify-between w-full flex-col gap-6 mt-2 mb-6">
      <button
        onClick={() => setShowInfoText(!showInfoText)}
        className="text-darkBlue md:pr-12 text-darkBlue font-bold flex flex-row gap-2 items-center"
      >
        Läs mer om roller
        {showInfoText ? (
          <FontAwesomeIcon icon={faChevronUp} />
        ) : (
          <FontAwesomeIcon icon={faChevronDown} />
        )}
      </button>
      {showInfoText && (
        <div>
          <h3>Företagsledare och Ordförande (Brf) kan:</h3>

          <ul className="list-disc py-4 px-6">
            <li className="listLi">Korrigera faktureringsuppgifter</li>
            <li className="listLi">Lägga till och ta bort användare</li>
            <li className="listLi">Hämta garantibelopp</li>
            <li className="listLi">Rapportera in årsuppgifter</li>
            <li className="listLi">
              Tillgång till Arbetsgivarguiden (kollektivavtal, arbetsrättslig information,
              blanketter och mallar, lönestatistik)
            </li>
            <li className="listLi">Nyhetsbrev</li>
          </ul>

          <h3>Personalansvarig/HR-ansvarig kan:</h3>
          <ul className="list-disc py-4 px-6">
            <li className="listLi">Korrigera faktureringsuppgifter</li>
            <li className="listLi">Lägga till och ta bort användare</li>
            <li className="listLi">Hämta garantibelopp</li>
            <li className="listLi">Rapportera in årsuppgifter</li>
            <li className="listLi">
              Tillgång till Arbetsgivarguiden (kollektivavtal, arbetsrättslig information,
              blanketter och mallar, lönestatistik)
            </li>
            <li className="listLi">Nyhetsbrev</li>
          </ul>

          <h3>Uppgiftslämnare Antal anställda/Lönesummor kan:</h3>
          <ul className="list-disc py-4 px-6">
            <li className="listLi">Korrigera faktureringsuppgifter</li>
            <li className="listLi">Rapportera in årsuppgifter</li>
            <li className="listLi">Hämta garantibelopp</li>
          </ul>

          <h3>Uppgiftslämnare Fastigo statistik kan:</h3>
          <ul className="list-disc py-4 px-6">
            <li>Kan endast innehas av en person/medlemsorganisation</li>
            <li className="listLi">Rapportera in lönestatistik</li>
          </ul>

          <h3>Informationsmottagare kan:</h3>
          <ul className="list-disc py-4 px-6">
            <li className="listLi">
              Tillgång till Arbetsgivarguiden (kollektivavtal, arbetsrättslig information,
              blanketter och mallar, lönestatistik){' '}
            </li>
            <li className="listLi">Nyhetsbrev</li>
          </ul>

          <h3>Huvudkontaktperson kan:</h3>
          <ul className="list-disc px-6">
            <li className="listLi">Korrigera faktureringsuppgifter</li>
            <li className="listLi">Lägga till och ta bort användare</li>
            <li className="listLi">Nyhetsbrev</li>
          </ul>
        </div>
      )}
    </div>
  )
}

export default RoleInfo
